import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { maxBy } from 'lodash';

const ColorLegend = ({ colorLegend }) => {
  const maxPoints = useMemo(() => {
    const maxShift = maxBy(colorLegend, 'points');
    const maxPoints = maxShift ? maxShift.points : 0;
    return maxPoints;
  }, [colorLegend]);

  return (
    <div className="color-legend">
      <h3 className="color-legend__title">Points Scored</h3>

      <div className="color-legend__item-container">
        <span className="color-legend__limit">0</span>

        {colorLegend.map(legendBin => (
          <span
            className="color-legend__item"
            key={legendBin.points}
            title={legendBin.points}
            style={{ backgroundColor: legendBin.color }}
          />
        ))}

        <span className="color-legend__limit">{maxPoints}</span>
      </div>
    </div>
  );
};

ColorLegend.propTypes = {
  colorLegend: PropTypes.array.isRequired,
};

export default ColorLegend;
